/** Required-field feedback for the theme's contact section. */
(() => {
  const elementName = 'netsoul-contact-form';
  if (customElements.get(elementName)) return;

  class NetSoulContactForm extends HTMLElement {
    constructor() {
      super();
      this.form = null;
      this.requiredFields = [];
      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.requiredFields = Array.from(this.querySelectorAll('.field-wrapper[data-required="true"]'));
      if (this.requiredFields.length === 0) return;

      this.form.addEventListener('submit', this.onSubmit);
      this.requiredFields.forEach((wrapper) => {
        wrapper.querySelector('.field__input, .text-area')?.addEventListener('input', this.onInput);
      });
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.requiredFields.forEach((wrapper) => {
        wrapper.querySelector('.field__input, .text-area')?.removeEventListener('input', this.onInput);
      });
    }

    onSubmit(event) {
      let valid = true;
      this.requiredFields.forEach((wrapper) => {
        const input = wrapper.querySelector('.field__input, .text-area');
        if (input && !input.value.trim()) {
          valid = false;
          wrapper.classList.add('field-wrapper--error');
          wrapper.querySelector('.field-wrapper__error-msg')?.classList.remove('hidden');
        }
      });
      if (!valid) event.preventDefault();
    }

    onInput(event) {
      const wrapper = event.target.closest('.field-wrapper');
      if (!wrapper) return;
      wrapper.classList.remove('field-wrapper--error');
      wrapper.querySelector('.field-wrapper__error-msg')?.classList.add('hidden');
    }
  }

  customElements.define(elementName, NetSoulContactForm);
})();
